/**
 * Java Apartments — Site-wide configuration constants.
 * Admin: update WHATSAPP_NUMBER to change the WhatsApp contact across the entire site.
 */

export const WHATSAPP_NUMBER = '255742886235'; // International format, no + or spaces

export const WHATSAPP_INQUIRY_MESSAGE =
  'Hello Java Apartments, I would like to make an inquiry about booking an apartment.';

export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_INQUIRY_MESSAGE)}`;

export const SITE_CONFIG = {
  name: 'Java Apartments',
  tagline: 'Stay in Comfort. Experience Luxury.',
  phone: '0742 886 235',
  email: 'javaapartmentstz@gmail.com',
  location: 'Kigamboni, Dar es Salaam, Tanzania',
  instagram: 'https://www.instagram.com/java_apartments?igsi=MXFlczhnNTAzaG9sZQ==',
  tiktok: 'https://www.tiktok.com/@java_apartments?_r=1&_t=ZS-99OZwt8XaKL',
};
